<div class="overflow_hidden circle unselectable relative"
	[ngStyle]="{'max-width': size,
				'width': size,
				'background-color': '#292929',
				'background-image':'url('+img+')'
				}">

	<div class="aspect_ratio"></div>
</div>